import React from 'react';
import {DocumentsContainer} from '../Containers/DocumentsContainer';

const Documents = (props) => {
	return (
		<DocumentsContainer />
	);
}

export default Documents;